import { Image, Text, View } from "@react-pdf/renderer";
import Logo from "./logo/DefaultLogo.png";

function Header({ companyData, quoteData }) {
  return (
    <View>
      <View
        style={{
          width: "auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          backgroundColor: "black",
          height: 70,
        }}
      >
        <Image src={Logo} alt="logo" style={{ width: "20%" }} />
      </View>

      <View
        style={{
          width: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "#000",
          padding: 10,
        }}
      >
        <Text style={{ fontWeight: 600, fontSize: 20, margin: 3 }}>
          Commercial Trucking Application & Quote for:
        </Text>
        <Text style={{ fontWeight: 600, fontSize: 20, margin: 3 }}>
          {companyData.name}
        </Text>
        <Text style={{ fontWeight: 600, fontSize: 20, margin: 3 }}>
          DOT#: {companyData.dot_number}
        </Text>
        <Text style={{ fontWeight: 600, fontSize: 13, margin: 3 }}>
          QUOTE#: {companyData.submission_number}
        </Text>
        <Text style={{ fontSize: 14, marginTop: 10, textAlign: "center" }}>
          Quote can be bound if all application information in this document is
          correct. If any discrepancies are found or any conditions of coverage
          are not met, your policy may be subject to automatic price change,
          non-renewal, or cancellation.{" "}
          <Text style={{ fontWeight: 700 }}>Quote is valid for 30 days.</Text>
        </Text>
      </View>
    </View>
  );
}

export default Header;
